import React from "react";
import QuantityPicker from "../../Offers/QuantityPicker/QuantityPicker";
import "./CartQuantityPicker.css";

import { useCart } from "../../../context/CartContext";

const CartQuantityPicker = ({ item }) => {
  const { increment, decrementOrRemove } = useCart();
  const value = item.quantity || 1;

  const handleChange = (next) => {
    if (next > 1) {
      alert("Multi-quantity purchases coming soon!\nFor now, only 1 eSIM per order.");
      return;
    }

    if (next > value) {
      increment(item);
    } else if (next < value) {
      decrementOrRemove(item.id);
    }
  };

  return (
    <div className="cart-quantity-picker">
      <QuantityPicker value={value} onChange={handleChange} min={0} max={99} />
    </div>
  );
};

export default CartQuantityPicker;
